import React from 'react'
import PropTypes from 'prop-types'
import { Stack, Snackbar, Alert, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { noop } from 'lodash'

const Actions = ({ additionalNode, onClose }) => (
  <Stack direction="row" alignItems="center" mt={-0.75}>
    {additionalNode}
    <IconButton pt={0} aria-label="close" color="inherit" onClick={onClose}>
      <CloseIcon />
    </IconButton>
  </Stack>
)

Actions.propTypes = {
  additionalNode: PropTypes.node,
  onClose: PropTypes.func,
}

Actions.defaultProps = {
  additionalNode: null,
  onClose: noop,
}

const AlertSnackbar = ({ isOpen, message, severity, handleClose, anchorOrigin, action }) => (
  <Stack spacing={2} sx={{ width: '100%' }}>
    <Snackbar open={isOpen} autoHideDuration={5000} onClose={handleClose} anchorOrigin={anchorOrigin}>
      <Alert
        elevation={6}
        variant="filled"
        onClose={handleClose}
        severity={severity}
        sx={{ width: '100%' }}
        action={action ? <Actions additionalNode={action} onClose={handleClose} /> : null}
      >
        {message}
      </Alert>
    </Snackbar>
  </Stack>
)

AlertSnackbar.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  message: PropTypes.string,
  severity: PropTypes.oneOf(['warning', 'success', 'error']),
  handleClose: PropTypes.func.isRequired,
  anchorOrigin: PropTypes.object,
  action: PropTypes.node,
}

AlertSnackbar.defaultProps = {
  severity: 'success',
  message: '',
  anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
  action: null,
}

export default AlertSnackbar
